/* @flow */

export const toJapanTime = (date: Date) => {
  // time is number of ms from Unix Epoch, in UTC
  const time = date.getTime();
  // Add offset of 9 hours
  const japanTime = time + 9 * 60 * 60 * 1000;
  return new Date(japanTime);
};
